import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';

import { PRD3010_R01LotDto, PRD3010_R01DowntimeDto, PRD3010_R01Dto, PRD3010_R01HeaderDto, PRD3010_R01InspectDto, PRD3010_R01ProductResultDto, PRD3010_R01DetailDto } from './Dto_PRD3010_R01';
import { PRD3010_R01Filter } from "./Store_PRD3010_R01";

const baseUrl = `${config.apiUrl}/PRD3010_R01`;

const getParams = (filter: Partial<PRD3010_R01Filter>, listLength?: number) => {	
	return {
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		compCd: filter.compCd || undefined,	
		compNm: filter.compNm || undefined,	
		workplaceCd: filter.workplaceCd || undefined,	
		itemCd: filter.itemCd || undefined,	
		itemNm: filter.itemNm || undefined,	
		workEmp: filter.workEmp || undefined,	
		workEmpNm: filter.workEmpNm || undefined,	

		listLength: listLength || 0
	}
}

export const getPRD3010_R01List = async (option: string, params: Partial<PRD3010_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<PRD3010_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getPRD3010_R01AllCount = async (params: Partial<PRD3010_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getPRD3010_R01One = async (productWorkNo: string) => {
	const url = `${baseUrl}/one/${productWorkNo}`;
	return await getData<ResponseDto<PRD3010_R01HeaderDto>>(url);
}

export const getPRD3010_R01ProductResultList = async (productOrderNo: string) => {
	const url = `${baseUrl}/productResult/${productOrderNo}`;
	return await getData<ResponseDto<PRD3010_R01ProductResultDto>>(url);
}

export const getPRD3010_R01LotList = async (itemCd: string) => {
	const url = `${baseUrl}/lot/${itemCd}`;

	return await getData<ResponseDto<PRD3010_R01LotDto[]>>(url);
}

export const getPRD3010_R01DetailList = async (itemCd: string, productQty: number, badQty: number, outWarehouseCd: string, logicCenter: string) => {
	const url = `${baseUrl}/detail`;

	return await getData<ResponseDto<PRD3010_R01DetailDto[]>>(url, { params: { 
			itemCd: itemCd,
			productQty: productQty,
			badQty: badQty,
			outWarehouseCd: outWarehouseCd,
			logicCenter: logicCenter
		} 
	});
}

export const getPRD3010_R01DetailStockList = async (itemCd: string, outWarehouseCd: string, logicCenter: string) => {
	const url = `${baseUrl}/detail/stock`;

	return await getData<ResponseDto<PRD3010_R01DetailDto[]>>(url, { params: { 
		itemCd: itemCd,
		outWarehouseCd: outWarehouseCd,
		logicCenter: logicCenter
		} 
	});
}

export const getPRD3010_R01TransportedInfo = async (productResultNo: string) => {
	const url = `${baseUrl}/detail/transported`;
	return await getData<ResponseDto<PRD3010_R01DetailDto[]>>(url, {
		params: {
			productResultNo: productResultNo
		}
	});
}

export const getPRD3010_R01InspectList = async (productResultNo: string) => {
	const url = `${baseUrl}/inspect/${productResultNo}`;

	return await getData<ResponseDto<PRD3010_R01InspectDto[]>>(url);
}

export const getPRD3010_R01DowntimeList = async (productResultNo: string) => {
	const url = `${baseUrl}/downtime/${productResultNo}`;

	return await getData<ResponseDto<PRD3010_R01DowntimeDto[]>>(url);
}

/** 저장 전 라벨용 LOT 번호 발급 (입고등록과 동일) */
export const createPRD3010_R01LotNo = async () => {
	const url = `${baseUrl}/lot/createLotNo`;
	return await getData<ResponseDto<string>>(url);
};

export const postPRD3010_R01 = async (data: PRD3010_R01Dto) => {

	const url = `${baseUrl}`;

	return await postData<PRD3010_R01Dto, ResponseDto<PRD3010_R01Dto>>(url, data);
}

export const patchPRD3010_R01 = async (data: PRD3010_R01Dto) => {

	const url = `${baseUrl}`;

	return await patchData<PRD3010_R01Dto, ResponseDto<PRD3010_R01Dto>>(url, data);
}

export const deletePRD3010_R01 = async (purchaseBillNo: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			purchaseBillNo
		}
	});
}

export const downloadExcel_PRD3010_R01 = async (option: string, purchaseBillNo: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			purchaseBillNo
		}
	})
}
export const getPdfBlob_PRD3010_R01 = async (productResultNo: string): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: { productResultNo },
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};